import createLucideIcon from '../createLucideIcon';

const ArrowLeftSquare = createLucideIcon('ArrowLeftSquare', [
  [
    'rect',
    {
      width: '18',
      height: '18',
      x: '3',
      y: '3',
      rx: '2',
      ry: '2',
      key: '1m3agn',
    },
  ],
  ['polyline', { points: '12 8 8 12 12 16', key: 'bz1698' }],
  ['line', { x1: '16', x2: '8', y1: '12', y2: '12', key: '1ckucc' }],
]);

export default ArrowLeftSquare;
